import { FileServiceResponse } from './interfaces/files-cache.interface';
import { CachePlugin } from './cache.plugin';

export class BuilderCachePlugin extends CachePlugin {

    public async getFile(filename: string, store: string): Promise<FileServiceResponse> {
        this.storeData = store;
        let response = await this.getFileData(filename);
        return response;
    }

    public async cacheFile(filename: string, data: any, store: string): Promise<FileServiceResponse> {
        this.storeData = store;
        return await this.cacheFileData(filename, data);
    }
    
    public async getDataByPrefix<T>(prefix: any, store: string): Promise<T[]> {
      this.storeData = store;
      let response = await this.getAllDataByPrefix(prefix);
      return response as T[];
    }

    public async removeFile(filename: any, store: string) {
      this.storeData = store;
      await this.removeFileData(filename);
    }

    public async removeAllStore(store: string) {
      this.storeData = store;
      await this.removeAllStoreData();
    }
    
}

export const BuilderCacheService = new BuilderCachePlugin();

export const BuilderCache = {
  install: (Vue) => {
    Vue.prototype.$BuilderCache = new BuilderCachePlugin();
  }
}